<div class="modal-backdrop" aria-hidden="true" (click)="backdropClick.emit()"></div>
